import { HtmlRenderer } from "./html_renderer"
import Ratio from "react-bootstrap/Ratio";
export const ArticleContent = ({ article }) => {

    const extractURL = (input) => {
        if (!input) return "";
        if (/^[a-zA-Z0-9_-]{11}$/.test(input)) return input;
        try {
            const u = new URL(input);
            if (u.hostname === "youtu.be") return u.pathname.slice(1);
            if (u.pathname.startsWith("/shorts/")) return u.pathname.split("/shorts/")[1].split(/[?&]/)[0];
            if (u.pathname.startsWith("/embed/")) return u.pathname.split("/embed/")[1].split(/[?&]/)[0];
            return u.searchParams.get("v") || "";
        } catch {
            return "";
        }
    }

    return (
        <div>
            {article.video_url &&
                <Ratio aspectRatio="16x9" className="mb-3">
                    <iframe
                        src={`https://www.youtube-nocookie.com/embed/${extractURL(article.video_url)}?rel=0`}
                        title="YouTube video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    />
                </Ratio>
            }
            {article.article_content && <HtmlRenderer html={article.article_content} />}
        </div>
    )
}